import { TenantHook } from "@models";
import { useStore } from "@stores";

import { useEffect } from "react";

export const useTenant = (id: string | undefined): TenantHook => {
  const { tenantStore } = useStore();
  const { loading, tenant } = tenantStore;

  useEffect(() => {
    id && tenantStore.get({ id: Number(id) });

    return () => tenantStore.clearTenant();
  }, [tenantStore, id]);

  return { tenant, loading };
};
